import ActionDispatcherService from './core/action-dispatcher.service';

export default angular
  .module('fizyweb.paycell.common.actions', [])
  .service('actionDispatcher', ActionDispatcherService).name;



// WEBPACK FOOTER //
// src/app/common/actions/actions.module.ts